<script lang="ts" setup>
import { AppTypography } from './index';

const { title = '', subtitle = '' } = defineProps<{
  title?: string;
  subtitle?: string;
}>();
</script>

<template>
  <v-card flat max-width="610" width="100%">
    <v-card-item v-if="title || subtitle" class="text-center mb-6">
      <v-card-title v-if="title">
        <AppTypography  type="title-4">{{ title }}</AppTypography>
      </v-card-title>
      <v-card-subtitle v-if="subtitle">
        <AppTypography element="p" type="body-1 mt-2">{{ subtitle }}</AppTypography>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>
.v-card {
  padding: 56px 0;
  border-radius: 16px;

  @media (min-width: 768px) {
    padding: 56px;
  }
}

.v-card-title {
  line-height: unset !important;
  white-space: normal;
}

.v-card-subtitle {
  white-space: normal;
}

.v-card-text {
  padding-left: 30px;
  padding-right: 30px;
}
.v-card {
  padding: 24px;
  border-radius: 16px;
  border: 1px solid #e5e5e5;
}
</style>
